import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class CommunicationsHttpUtil {

  public static prepareParamsGetChats(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.active || params.active === 0) {
      urlParams.append('active', params.active);
    }
    if (params.filter) {
      urlParams.append('filter', params.filter);
    }
    return urlParams;
  }

  public static prepareParamsCreateDialog(params) {
    let formData: FormData = new FormData();

    if (params.securityToken) {
      formData.append('securityToken', params.securityToken);
    }
    if (params.chatType || params.chatType === 0) {
      formData.append('chatType', params.chatType);
    }
    if (params.chatTheme) {
      formData.append('chatTheme', params.chatTheme);
    }
    if (params.chatMessage) {
      formData.append('chatMessage', params.chatMessage);
    }
    if (params.lawInstanceId || params.lawInstanceId === 0) {
      formData.append('lawInstanceId', params.lawInstanceId);
    }
    if (params.attachment || params.attachment === '') {
      formData.append('attachment', params.attachment);
    }
    return formData;
  }

  public static prepareParamsSendMessage(params) {
    let formData: FormData = new FormData();

    if (params.securityToken) {
      formData.append('securityToken', params.securityToken);
    }
    if (params.action || params.action === 0) {
      formData.append('action', params.action);
    }
    if (params.chatMessage || params.action === 0) {
      formData.append('chatMessage', params.chatMessage);
    }
    if (params.attachment || params.attachment === '') {
      formData.append('attachment', params.attachment);
    }
    return formData;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/communications.util.ts